export enum AlignRule{
	Left,
  Right,
  Center,
  Justify
}